import { render } from "./SelectDnTService.vue?vue&type=template&id=37c3f4dc&scoped=true"
import script from "./SelectDnTService.vue?vue&type=script&lang=js"
export * from "./SelectDnTService.vue?vue&type=script&lang=js"

import "./SelectDnTService.vue?vue&type=style&index=0&id=37c3f4dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37c3f4dc"]])

export default __exports__